/* Corporate lead capture. Injects two qualification boxes into the article body,
   branches on volume, adds a desktop-only exit-intent popup, reports to GA4.
   Submission is NATIVE (full reload): this shop has Shopify bot protection on, so
   AJAX posts to /contact are rejected with "Missing CAPTCHA token". Before submit we
   stash which box/volume was used; on the way back we re-open that box on the
   thank-you state Liquid rendered. Plan: corporate-lead-capture-plan.md */
(function () {
  "use strict";
  var SUBMITTED = "clc:submitted";
  var DISMISSED = "clc:dismissed";
  var SHOWN = "clc:popupShown";
  var CTX = "clc:ctx";
  var POPUP_MIN_MS = 10000;
  var DISMISS_DAYS = 30;

  var root = document.querySelector("[data-clc]");
  if (!root) return;

  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function ss(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }

  /* Plan 7.2 step 5: the welcome popup must not run on this article - the boxes
     already collect the B2C signup, and two offers competing here is what the plan
     rules out. Scoped by construction: this script is only loaded by the section,
     which renders on the target article, so the popup keeps working elsewhere. */
  (function stripFormsPopup() {
    function strip() {
      var els = document.querySelectorAll("shopify-forms-embed");
      for (var i = 0; i < els.length; i++) {
        if (els[i].parentNode) els[i].parentNode.removeChild(els[i]);
      }
    }
    strip();
    try {
      new MutationObserver(strip).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  })();

  var gaOn = root.getAttribute("data-ga") === "1";
  /* Only the direct gtag() call is trusted here. This shop loads GA4 through the
     Google & YouTube channel, which does not read the window.dataLayer queue we can
     reach - events pushed there are silently dropped. generate_lead fires on
     DOMContentLoaded right after a native form post, before gtag.js has run, so
     queue locally and flush as soon as gtag exists. */
  var pending = [];
  function flush() {
    if (typeof window.gtag !== "function") return false;
    while (pending.length) {
      var e = pending.shift();
      window.gtag("event", e[0], e[1]);
    }
    return true;
  }
  function track(name, params) {
    if (!gaOn) return;
    pending.push([name, params || {}]);
    if (flush()) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (flush() || tries > 60) clearInterval(t);
    }, 250);
  }

  /* The post is one HTML blob, so anchor on heading text. */
  function findHeading(needle) {
    if (!needle) return null;
    var want = needle.trim().toLowerCase();
    var hs = document.querySelectorAll("article h1, article h2, article h3, main h2, main h3");
    for (var i = 0; i < hs.length; i++) {
      if ((hs[i].textContent || "").trim().toLowerCase().indexOf(want) !== -1) return hs[i];
    }
    return null;
  }

  /* Insert after the WHOLE section the heading opens: stop at the next heading of
     the same or higher level. */
  function insertAfterSection(heading, node) {
    var level = parseInt(heading.tagName.substring(1), 10);
    var cur = heading;
    while (cur.nextElementSibling) {
      var next = cur.nextElementSibling;
      var m = /^H([1-6])$/.exec(next.tagName);
      if (m && parseInt(m[1], 10) <= level) break;
      cur = next;
    }
    cur.parentNode.insertBefore(node, cur.nextSibling);
  }

  function build(which) {
    var tpl = root.querySelector('[data-clc-tpl="' + which + '"]');
    if (!tpl) return null;
    return tpl.content.cloneNode(true).firstElementChild;
  }

  var corp = root.querySelector("[data-clc-corp]");
  var b2c = root.querySelector("[data-clc-b2c]");

  function park(panel) {
    if (!panel) return;
    panel.hidden = true;
    root.appendChild(panel);
  }

  function revealIn(box, panel) {
    var slot = box.querySelector("[data-clc-slot]");
    if (!slot || !panel) return;
    slot.appendChild(panel);
    panel.hidden = false;
    slot.hidden = false;
  }

  function placeBox(which) {
    var box = build(which);
    if (!box) return null;
    var anchor = root.getAttribute(which === "top" ? "data-anchor-top" : "data-anchor-bottom");
    var h = findHeading(anchor);
    /* Top box sits directly ABOVE the survey heading (asked for 2026-08-08) so it is
       the first thing after the intro; the lower box still follows its whole section. */
    if (h) {
      if (which === "top") h.parentNode.insertBefore(box, h);
      else insertAfterSection(h, box);
      return box;
    }
    /* Fallback so a renamed heading never drops the box entirely. */
    var hs = document.querySelectorAll("article h2, main h2");
    var target = hs.length ? hs[which === "top" ? 0 : Math.max(0, hs.length - 2)] : null;
    if (!target) return null;
    if (which === "top") target.parentNode.insertBefore(box, target);
    else insertAfterSection(target, box);
    if (window.console) console.warn("[clc] heading not found, used fallback:", anchor);
    return box;
  }

  /* Coming back from a native submit: Liquid already rendered the thank-you inside
     the relevant form, so just re-open the box it was submitted from. */
  function showPostedState() {
    var posted = root.querySelector("[data-clc-posted]");
    if (!posted) return false;
    var arm = posted.getAttribute("data-clc-posted");
    var ctx = {};
    try { ctx = JSON.parse(ss(CTX) || "{}"); } catch (e) {}
    ssDel(CTX);
    lsSet(SUBMITTED, "1");

    var which = ctx.placement === "bottom" ? "bottom" : "top";
    var box = placeBox(which);
    if (box) {
      revealIn(box, arm === "b2c" ? b2c : corp);
      try { box.scrollIntoView({ block: "center" }); } catch (e) {}
    }
    track("generate_lead", {
      method: arm === "b2c" ? "newsletter_b2c" : "corporate",
      volume: ctx.volume || "",
      placement: ctx.placement || ""
    });
    return true;
  }

  function wire(box, placement, observe) {
    var btns = box.querySelectorAll("[data-vol]");
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener("click", function () {
        var vol = btn.getAttribute("data-vol");
        Array.prototype.forEach.call(btns, function (b) {
          if (b.classList.contains("clc-btn")) b.setAttribute("aria-pressed", b === btn ? "true" : "false");
        });
        track("lead_qualify_click", { volume: vol, placement: placement });
        park(corp); park(b2c);
        var slot = box.querySelector("[data-clc-slot]");
        if (slot) slot.hidden = true;
        if (vol === "b2c") {
          ssSet(CTX, JSON.stringify({ arm: "b2c", volume: "", placement: placement }));
          revealIn(box, b2c);
        } else {
          ssSet(CTX, JSON.stringify({ arm: "corp", volume: vol, placement: placement }));
          var field = corp.querySelector("[data-clc-vol-field]");
          if (field) field.value = vol;
          revealIn(box, corp);
        }
      });
    });

    if (observe && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { track("lead_form_view", { placement: placement }); io.disconnect(); }
        });
      }, { threshold: 0.4 });
      io.observe(box);
    }
  }

  /* Plan 3 + 5.6 + 6: exit-intent popup, desktop only, never on mobile. */
  function setupExitPopup() {
    if (!root.querySelector('[data-clc-tpl="exit"]')) return;
    var desktop = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine) and (min-width: 1024px)").matches;
    if (!desktop) return;
    if (ss(SHOWN)) return;
    var until = parseInt(ls(DISMISSED) || "0", 10);
    if (until && Date.now() < until) return;

    var loadedAt = Date.now();
    var modal = null;

    function close(remember) {
      if (!modal) return;
      if (remember) lsSet(DISMISSED, String(Date.now() + DISMISS_DAYS * 864e5));
      park(corp); park(b2c);
      modal.parentNode.removeChild(modal);
      modal = null;
      document.removeEventListener("keydown", onKey);
    }
    function onKey(e) { if (e.key === "Escape") close(true); }

    function open() {
      if (modal) return;
      modal = build("exit");
      if (!modal) return;
      document.body.appendChild(modal);
      ssSet(SHOWN, "1");
      wire(modal.querySelector('[data-clc-box="exit"]'), "exit_intent", false);
      track("lead_form_view", { placement: "exit_intent" });
      Array.prototype.forEach.call(modal.querySelectorAll("[data-clc-close]"), function (el) {
        el.addEventListener("click", function () { close(true); });
      });
      document.addEventListener("keydown", onKey);
      var first = modal.querySelector(".clc-btn");
      if (first) first.focus();
      document.removeEventListener("mouseout", onOut);
    }

    function onOut(e) {
      if (Date.now() - loadedAt < POPUP_MIN_MS) return;
      if (e.relatedTarget || e.toElement) return;
      if (e.clientY > 0) return;
      open();
    }
    document.addEventListener("mouseout", onOut);
  }

  function start() {
    if (showPostedState()) return;
    /* Plan 6: someone who already submitted never sees any of this again. */
    if (ls(SUBMITTED)) return;
    ["top", "bottom"].forEach(function (which) {
      var box = placeBox(which);
      if (box) wire(box, which, true);
    });
    setupExitPopup();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();